"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MUTATE_SEND_DIFFERENT_SUPERVISOR = exports.MUTATE_SEND_SUPERVISOR_REVIEW = exports.CANCEL_FIRM_MEMBERSHIP = exports.GET_CENTER_SERVICE_CONTRACTS = exports.GET_CENTER_MEMBERSHIP_INVOICES = exports.MUTATE_SEND_FIRM_SUB_EMAIL = exports.MUTATE_SEND_GDPR_REQUEST = exports.MUTATE_SEND_CALIFORNIA_LAW = exports.GET_CENTER_MEMBERSHIPS_FIRM_HIERARCHY = exports.MUTATE_SEND_PARTNER_INVITE = exports.GET_ALL_CENTER_MEMBERSHIPS = exports.GET_CENTER_MEMBERSHIPS = exports.GET_CENTER_ORGANIZATIONS_BY_ACCOUNT_IDS = void 0;
exports.GET_CENTER_ORGANIZATIONS_BY_ACCOUNT_IDS = `
  {
    centerOrganizations {
            id
            name
            creditHoldStatus
            hasAICPAUid
            isFirmBillingEnabled
            parentId
            currentParentId
            billingAddress {
              addressLine1
              city
              state
              zipCode
              country
            }
            shippingAddress {
              addressLine1
              city
              state
              zipCode
              country
            }
            numCPA
            isPCAOBOrganization
            PCAOBNumOfIssuers
            phone
            type
          }
  }
`;
exports.GET_CENTER_MEMBERSHIPS = `
	query getCenterMemberships($organizationId: String, $adminAccountId: String!, $membershipStatus: String!, $date: String!) {
		getCenterMemberships(organizationId: $organizationId, adminAccountId: $adminAccountId, membershipStatus: $membershipStatus, date: $date){
      id
      name
      accountKey
      accessUrl
      adminAccountId
      endDate
      firmMembershipType
      membershipBody
      memberSinceDate
      status
      terminationComments
      terminationReason
      membershipTerm {
        id
        name
        applicationPartId
        expiryDate
        isPaidByFirm
        membershipId
        orderLineItemId
        productId
        startDate
      }
      inactiveTerms {
        id
        name
        applicationPartId
        expiryDate
        isPaidByFirm
        membershipId
        orderLineItemId
        productId
        startDate
      }
      numberOfCpa
      admin {
        name
        firstName
        lastName
        email
        parentId
        ultimateParentOrgId
      }
    }
	}
`;
exports.GET_ALL_CENTER_MEMBERSHIPS = `
	query getAllCenterMemberships($organizationId: String) {
		getAllCenterMemberships(organizationId: $organizationId){
      id
      name
      accountKey
      accessUrl
      adminAccountId
      endDate
      firmMembershipType
      membershipBody
      memberSinceDate
      status
      terminationComments
      terminationReason
      membershipTerm {
        id
        name
        applicationPartId
        expiryDate
        isPaidByFirm
        membershipId
        orderLineItemId
        productId
        startDate
      }
      inactiveTerms {
        id
        name
        applicationPartId
        expiryDate
        isPaidByFirm
        membershipId
        orderLineItemId
        productId
        startDate
      }
      numberOfCpa
      admin {
        name
        firstName
        lastName
        email
        parentId
        ultimateParentOrgId
      }
    }
	}
`;
exports.MUTATE_SEND_PARTNER_INVITE = `
  mutation sendPartnerInviteEmail($partnerInvite: PartnerInvite) {
    sendPartnerInviteEmail(partnerInvite: $partnerInvite)
  }
`;
exports.GET_CENTER_MEMBERSHIPS_FIRM_HIERARCHY = `
	query getCenterMembershipsByFirmHierarchy($organizationIds: [String]) {
		getCenterMembershipsByFirmHierarchy(organizationIds: $organizationIds) {
      id
      name
      accountKey
      accessUrl
      adminAccountId
      endDate
      firmMembershipType
      membershipBody
      memberSinceDate
      status
      terminationComments
      terminationReason
      membershipTerm {
        id
        name
        applicationPartId
        expiryDate
        isPaidByFirm
        membershipId
        orderLineItemId
        productId
        startDate
      }
      numberOfCpa
      admin {
        name
        firstName
        lastName
        email
        parentId
        ultimateParentOrgId
      }
    }
  }
`;
exports.MUTATE_SEND_CALIFORNIA_LAW = `
  mutation sendCaliforniaLawEmail($californiaLaw: CaliforniaLaw) {
    sendCaliforniaLawEmail(californiaLaw: $californiaLaw)
  }
`;
exports.MUTATE_SEND_GDPR_REQUEST = `
  mutation sendGdprRequestEmail($gdprRequest: GdprRequest) {
    sendGdprRequestEmail(gdprRequest: $gdprRequest)
  }
`;
exports.MUTATE_SEND_FIRM_SUB_EMAIL = `
  mutation sendFirmSubEmail($firmSubEmail: FirmSubEmail) {
    sendFirmSubEmail(firmSubEmail: $firmSubEmail)
  }
`;
exports.GET_CENTER_MEMBERSHIP_INVOICES = `
    query ($rootOrganizationId: String!, $isPaid: Boolean, $nextPage: String) {
      getCenterMembershipInvoices(rootOrganizationId: $rootOrganizationId, isPaid: $isPaid, nextPage: $nextPage) {
        centerMembershipInvoices {
          id
          dueDate
          invoiceDate
          amount
          balance
          invoiceNumber
          status
          accountId
          orderNumber
          type
        }
        nextPage
      }
    }
`;
exports.GET_CENTER_SERVICE_CONTRACTS = `
  {
    getCenterServiceContracts {
      id
		  productName
		  endDatetime
		  totalQuantity
      allocatedQuantity
      orderProductId
      deprovisionAllowed
      contractLineItems {
        contactId
        contactEmail
        contactName
        contractLineItemId
      }
    }
  }
`;
exports.CANCEL_FIRM_MEMBERSHIP = `
  mutation cancelFirmMembership($cancellationDetails: FirmMembershipCancellationDetails, $isSuspend: Boolean){
    cancelFirmMembership(cancellationDetails: $cancellationDetails, isSuspend: $isSuspend)
  }
`;
exports.MUTATE_SEND_SUPERVISOR_REVIEW = `
  mutation sendSupervisorReviewEmail($supervisorReview: SupervisorReview) {
    sendSupervisorReviewEmail(supervisorReview: $supervisorReview)
`;
exports.MUTATE_SEND_DIFFERENT_SUPERVISOR = `
  mutation sendDifferentSupervisorEmail($differentSupervisor: DifferentSupervisor) {
    sendDifferentSupervisorEmail(differentSupervisor: $differentSupervisor)
  }
`;
//# sourceMappingURL=center-admin-queries.js.map